<template>
	<a class="text-decoration-none" v-if="!isPodcast" :href="item.link" target="_blank">
		<div class="rss-card d-flex justify-space-between pa-3 elevation-0">
			<div class="rss-card__picture-wrapper" v-if="item.picture">
				<img class="rss-card__picture" :src="pictureSrc" />
			</div>
			<div class="rss-card__info">
				<v-card-text
					:class="{
						'rss-card__info-date mb-1': true,
						'rss-card__info-date-left': !item.picture && !isPodcast,
					}"
				>
					{{ createdDate }}
				</v-card-text>
				<v-card-title class="rss-card__info-title">
					{{ item.title }}
				</v-card-title>
				<v-card-text class="rss-card__info-text" v-html="linkifiedText"></v-card-text>
			</div>
			<div v-if="!isPodcast" class="rss-card__chevron-wrapper">
				<Icon type="chevron_right" color="#9B9B9B" :size="16" />
			</div>
		</div>
	</a>
	<div v-else class="rss-card pa-3 elevation-0" @click="toggleRssPodcast">
		<div class="rss-card__picture-wrapper" v-if="item.picture || (!item.picture && isPodcast)">
			<img class="rss-card__picture" :src="pictureSrc" />
			<div v-if="isPodcast" class="rss-card__play-btn" @click="handlePodcastClick">
				<Icon
					:type="play && isCurrentPodcast ? 'pause' : 'play'"
					color="white"
					:size="24"
				/>
			</div>
		</div>
		<div class="rss-card__info">
			<v-card-text
				:class="{
					'rss-card__info-date mb-1': true,
					'rss-card__info-date-left': !item.picture && !isPodcast,
				}"
			>
				{{ createdDate }}
			</v-card-text>
			<v-card-title class="rss-card__info-title">
				{{ item.title }}
			</v-card-title>
			<v-card-text class="rss-card__info-text" v-html="linkifiedText"></v-card-text>
		</div>
		<div v-if="!isPodcast" class="rss-card__chevron-wrapper">
			<Icon type="chevron_right" color="#9B9B9B" :size="16" />
		</div>
	</div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import podcastImg from '@/assets/images/podcast.svg'
import Dwh from '@/mixins/Dwh'

export default {
	mixins: [Dwh],
	props: {
		isPodcast: {
			type: Boolean,
			default: false,
		},
		item: {
			type: Object,
			default: () => ({}),
		},
		podcasts: {
			type: Array,
			default: () => [],
		},
		index: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			podcastImg,
		}
	},
	computed: {
		...mapGetters('rss', ['playlist', 'currentPodcast', 'play']),

		createdDate() {
			return moment(this.item.date * 1000).fromNow()
		},
		isCurrentPodcast() {
			return _.isEqual(this.item, this.currentPodcast)
		},
		pictureSrc() {
			return this.item.picture || this.podcastImg
		},
		linkifiedText() {
			const urlRegex = /((https?:\/\/)[^\s]+)/g
			return this.item.text.replace(urlRegex, (url) => {
				return `<a href="${url}" target="_blank" class="rss-link">${url}</a>`
			})
		},
	},
	methods: {
		...mapActions('rss', ['setPodcast', 'togglePlay']),
		toggleRssPodcast() {
			this.sendTrigger({
				category: 'Content',
				action: 'rss_post_open',
				module: 'RSS',
				title: this.item.title,
				data: this.$route.query.feed_id,
			})
		},

		handlePodcastClick() {
			if (this.isCurrentPodcast) {
				this.togglePlay(!this.play)
			} else {
				this.setPodcast({
					podcast: this.item,
					playlist: this.podcasts,
					podcastNumber: this.index,
				})
				this.sendTrigger({
					category: 'Content',
					action: 'click_play_button',
					module: 'Podcast',
					title: this.item.title,
					data: this.$route.query.feed_id,
				})
				!this.play && this.togglePlay(true)
			}
		},
	},
}
</script>
<style lang="scss">
.rss-card {
	background-color: #ffffff;
	border: 1px solid #e2e2e2;
	display: flex;
	flex-wrap: nowrap;
	align-items: flex-start;
	margin-bottom: 8px;
	border-radius: 8px !important;
	text-decoration: unset !important;
	cursor: unset !important;

	@media (max-width: 600px) {
		flex-direction: column;
		align-items: center;
	}

	&__picture {
		width: 148px;
		height: 148px;
		background-color: #aaa;
		object-fit: cover;
		border-radius: 8px;

		&-wrapper {
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-right: 16px;

			@media (max-width: 600px) {
				margin: 0;
			}
		}
	}

	&__info {
		display: flex;
		flex-direction: column;
		font-family: 'Inter', sans-serif;

		&-date {
			color: #9b9b9b;
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;

			&-left {
				text-align: left !important;
			}

			@media (max-width: 600px) {
				margin-top: 4px;
				text-align: center;
			}
		}

		&-title {
			font-size: 18px;
			font-weight: 700;
			color: var(--accent-color);
			line-height: 21.94px;
			padding: 0;
			margin-bottom: 10px;
			word-break: break-word;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;

			@media (max-width: 600px) {
				font-size: 14px;
			}
		}

		&-text {
			font-size: 14px;
			color: var(--accent-color);
			line-height: 17.07px;
			word-break: break-word;
			a {
				color: var(--link) !important;
				text-decoration: none !important;

				&:hover {
					text-decoration: none;
				}
			}
		}
	}

	&__chevron {
		&-wrapper {
			align-self: center;
			margin-left: 12px;
			@media (max-width: 600px) {
				display: none !important;
			}
		}
	}

	&__play-btn {
		height: 52px;
		width: 52px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: var(--accent-color);
		border-radius: 50%;
		border: 2px solid #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

			i {
				transform: scale(1.2);
			}
		}
	}
}
.rss-link {
	color: green;
	text-decoration: underline;

	&:hover {
		text-decoration: none;
	}
}
</style>
